<script>
import SideMenuGroup          from '../side-menu-group';
import ItemTermsAndGuidelines from '../side-menu-item/terms-and-guidelines';
import ItemCompany            from '../side-menu-item/company';

export default {
  name  : 'side-menu-group-company-info',
  mixins: [SideMenuGroup],
  data  : function() {
    return {
      menuItems: [
        ItemTermsAndGuidelines,
        ItemCompany,
      ],
      analytics: { label: 'side_menu_group_company' },
    };
  },
};
</script>
